/*eslint-disable*/
// @ts-nocheck
import type { LoginBoxProps } from 'src/@types'
import { useMemo } from 'react'
import { type FormInstance } from 'antd'
import { LOGIN_TYPE } from 'src/@types/enum'
import { type LoginBoxState } from './'
import { getCodeUrl, postApi } from 'src/api'
import * as formStructure from 'src/utils/formStructure'

export function getFormStructure(type: LOGIN_TYPE) {
  switch (type) {
    case LOGIN_TYPE.ACCOUNT:
      return formStructure.createAccountStructure()
    case LOGIN_TYPE.EMAIL:
      return formStructure.createEmailStructure()
    case LOGIN_TYPE.PHONE:
      return formStructure.createPhoneStructure()
  }
}

interface LoginUtilsParams extends Pick<LoginBoxProps, 'getRootState'> {
  getNewState: () => LoginBoxState
  setState: UseStatesDispatch<LoginBoxState>
  formRef: React.MutableRefObject<FormInstance<{
    user: string,
    password: string,
    imageCode: string
  }>>
}

export function useLoginUtils({ setState, getNewState, getRootState, formRef }: LoginUtilsParams) {
  return useMemo(() => {

    /** 切换tab */
    function toggleTab(tabType: LOGIN_TYPE) {
      setState({
        tabType,
        formStructure: getFormStructure(tabType)
      })
    }

    /** 登陆 */
    async function login() {
      try {
        const { tabType, isBintang } = getNewState()
        const { requestData: { openImgVerify }, lang } = getRootState()
        const formData = await formRef.current.validateFields()
        AES.setSecret('aas-apex')
        // console.log(formData, tabType)
        // console.log(tabType == 1 ? '' : formData.verifyCode)
        const res = await postApi('/oauth2/login')({
          // 用户名
          user: tabType == 2 ? formData.email : formData.user,
          // 密码
          password: tabType == 1 ? AES.encryptBase64(formData.password) : '',
          /**
           * 登陆类型
           * 	1、用户名+密码：UsernameAndPassword
           * 	2、用户名+密码+验证码：UsernameAndPasswordAndVerifyCode
           * 	3、用户名+验证码：UsernameAndVerifyCode
           * 	4、用户名+U盾：UsernameAndUKey
           * 	5、U盾：UKey
          */
          mode: openImgVerify ? 'UsernameAndPasswordAndVerifyCode' : 'UsernameAndPassword',
          // ext参数
          ext: {
            // 图形验证码值 	
            imageCode: formData.imageCode,
            //  int类型 1-账号密码登录（user，password必填）；2-邮箱；3-手机
            type: Number(getNewState().tabType),
            // 短信验证码或邮箱验证码值
            code: tabType == 1 ? '' : formData.verifyCode,
            // 开启免登录
            isBintang: isBintang ? 1 : 0
          },
          // 国际化参数（zh-cn或en...）
          lang
        })
        if (res.data === livecloud.REQUEST_ERROR) {
          // 找到img标签id为imgVerify，重新获取验证码
          const img = document.getElementById('imgVerify')
          formRef.current.setFieldValue('imageCode', '')
          if (img) {
            img.src = getCodeUrl()
          }
          return
        }
        location.replace(res.redirect)
      } catch (e) {
        console.log(e)
      }
    }

    /**企业微信登录 */
    function workWeChatLogin(url: string) {
      const { isBintang } = getNewState()
      const newUrl = url + encodeURIComponent(location.href + `&isBintang=${isBintang ? 1 : 0}`)
      if (url) {
        location.href = newUrl
      }
    }
    /**微信登录 */
    function weChatLogin(url: string) {
      const { isBintang } = getNewState()
      const newUrl = url + encodeURIComponent(location.href + `&isBintang=${isBintang ? 1 : 0}` + `&isWeChat=1`)
      
      if (url) {
        location.href = newUrl
      }
    }

    function handleIsBintang() {
      const { isBintang } = getNewState()
      setState('isBintang', !isBintang)
    }

    return {
      /** 切换tap */
      toggleTab,
      /** 登陆 */
      login,
      /** 企业微信登录 */
      workWeChatLogin,
      /** 微信登录 */
      weChatLogin,
      /** 免登录 */
      handleIsBintang
    }

  }, [])
}